module.exports = __webpack_public_path__ + "img/Suntrust Bank Nigeria Limited.50f4eb0a.png";